import React, { Component, createRef, Suspense, lazy } from 'react';

// Lazy-load the Lottie overlay so lottie-web is code-split (not in main bundle).
// The overlay lives OUTSIDE components/ to avoid require.context bundling it.
const ConversionLoadingOverlay = lazy(() => import(
  /* webpackChunkName: "conversion-overlay" */
  '../../../loading_animation/conversion_loading_overlay'
));

class DocumentDropZone extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dragging: false,
            addBlankSlides: true,
            aiMode: false,
        };
        this.fileInputRef = createRef();
        this.dragCounter = 0;
    }

    handleFile(file) {
        if (!file) return;

        const ext = file.name.split('.').pop().toLowerCase();
        if (ext !== 'pages' && ext !== 'docx') {
            alert('Please upload a .pages or .docx file.');
            return;
        }

        if (this.state.aiMode) {
            // AI mode: send directly to AI draft endpoint
            if (this.props.onAiFile) {
                this.props.onAiFile(file, null, this.state.addBlankSlides);
            }
        } else {
            // Legacy mode: pass directly to parent
            if (this.props.onFile) {
                this.props.onFile(file, this.state.addBlankSlides);
            }
        }
    }

    handleFileInput(e) {
        const file = e.target.files[0];
        this.handleFile(file);
        e.target.value = '';
    }

    handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ dragging: false });
        this.dragCounter = 0;

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.handleFile(e.dataTransfer.files[0]);
            e.dataTransfer.clearData();
        }
    }

    handleDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ dragging: true });
        }
    }

    handleDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({ dragging: false });
        }
    }

    handleDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    render() {

        const borderClass = this.state.dragging
            ? 'border-blue-500 bg-blue-50'
            : 'border-gray-300 bg-white';

        return (
            <div>
                <Suspense fallback={null}>
                    <ConversionLoadingOverlay visible={this.props.loading || this.state.extracting} />
                </Suspense>
                <div
                    className={"border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors duration-150 mb-4 " + borderClass}
                    onDrop={(e) => this.handleDrop(e)}
                    onDragEnter={(e) => this.handleDragEnter(e)}
                    onDragLeave={(e) => this.handleDragLeave(e)}
                    onDragOver={(e) => this.handleDragOver(e)}
                    onClick={() => this.fileInputRef.current.click()}
                >
                    <svg className="mx-auto h-10 w-10 text-gray-400 mb-3" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                        <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="text-gray-600 mb-2">
                        {this.state.dragging ? 'Drop file here' : 'Import .pages or .docx file'}
                    </p>
                    <p className="text-gray-400 text-sm">Drag and drop or click to browse</p>
                    <input
                        ref={this.fileInputRef}
                        type="file"
                        className="hidden"
                        accept=".pages,.docx"
                        onChange={(e) => this.handleFileInput(e)}
                    />
                </div>

                <div className="flex items-center space-x-6 mb-6">
                    <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                            type="checkbox"
                            className="form-checkbox h-4 w-4 text-blue-500 rounded-sm"
                            checked={this.state.aiMode}
                            onChange={(e) => this.setState({ aiMode: e.target.checked })}
                        />
                        <span className="text-sm text-gray-600">Use AI to format slides</span>
                        <span className="inline-flex items-center ml-2 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                            <svg className="w-3 h-3 mr-1" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"/></svg>
                            Beta
                        </span>
                    </label>

                    <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                            type="checkbox"
                            className="form-checkbox h-4 w-4 text-blue-500 rounded-sm"
                            checked={this.state.addBlankSlides}
                            onChange={(e) => this.setState({ addBlankSlides: e.target.checked })}
                        />
                        <span className="text-sm text-gray-600">Add blank slides between content</span>
                    </label>
                </div>

                {this.props.error && (
                    <div className="mb-6 p-3 bg-red-100 border border-red-300 rounded-sm text-red-700 text-sm">
                        {this.props.error}
                    </div>
                )}
            </div>
        );
    }
}

export default DocumentDropZone;
